export const commonSetStorageCommunity = (communityLink: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('communityLink', communityLink);
  }
};

export const commonGetStorageCommunity = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('communityLink');
  }
  return '';
};

export const commonClearStorageCommunity = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('communityLink');
  }
};
